<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ChTitle" id="ch20"><a id="ch20aa"></a><a id="ch20a"></a><a id="page_45"></a><a href="#/Contents#rch20"><span class="underline"><i>MICHIN SAEKKI!</i></span></a></h3>
<p class="center1"><span><i>Translated into English, these international insults may sound silly, but trust us: do not say them in their native lands!</i></span></p>
<p class="noindent"><span><span class="dropcap">G</span><b><i>OSPOD ODIN DA TA PRATI</i>!</b></span></p>
<p class="noindent"><span>(Bulgarian)</span></p>
<p class="noindent"><span><i>Meaning</i>: “Go to h*ll!”</span></p>
<p class="noindent"><span><i>Literally</i>: “God sends you to the fire!”</span></p>
<p class="noindent1a"><span><b><i>FANTONG</i>!</b></span></p>
<p class="noindent"><span>(Mandarin)</span></p>
<p class="noindent"><span><i>Meaning:</i> “Useless!”</span></p>
<p class="noindent"><span><i>Literally:</i> “Rice bucket!”</span></p>
<p class="noindent1a"><span><b><i>BACHE SHEYTOON</i>!</b></span></p>
<p class="noindent"><span>(Farsi)</span></p>
<p class="noindent"><span><i>Meaning:</i> “Grow up!”</span></p>
<p class="noindent"><span><i>Literally:</i> “You Satan child!”</span></p>
<p class="noindent1a"><span><b><i>CON COMME LA BALA</i>!</b></span></p>
<p class="noindent"><span>(French)</span></p>
<p class="noindent"><span><i>Meaning:</i> “Very stupid!”</span></p>
<p class="noindent"><span><i>Literally:</i> “Stupid like a broom!”</span></p>
<p class="noindent1a"><span><b><i>GROZNI SI KATO SALATA</i>!</b></span></p>
<p class="noindent"><span>(Bulgarian)</span></p>
<p class="noindent"><span>Meaning: “You’re ugly!”</span></p>
<p class="noindent"><span>Literally: “You look like a salad!”</span></p>
<p class="noindent1a"><span><b><i>NAMEH TEN-NO</i>!</b></span></p>
<p class="noindent"><span>(Japanese)</span></p>
<p class="noindent"><span><i>Meaning:</i> “You want to fight!”</span></p>
<p class="noindent"><span><i>Literally:</i> “What are you licking?”</span></p>
<p class="noindent1a"><span><b><i>DRECKSCLEUDER</i>!</b></span></p>
<p class="noindent"><span>(German)</span></p>
<p class="noindent"><span><i>Meaning:</i> “Potty mouth!”</span></p>
<p class="noindent"><span><i>Literally:</i> “Dirt slingshot!”</span></p>
<p class="noindent1a"><span><b><i>YA NA’AL</i>!</b></span></p>
<p class="noindent"><span>(Hebrew)</span></p>
<p class="noindent"><span><i>Meaning:</i> “You idiot!”</span></p>
<p class="noindent"><span><i>Literally:</i> “You shoe!”</span></p>
<p class="noindent1a"><span><b><i>MICHIN SAEKKI</i>!</b></span></p>
<p class="noindent"><span>(Korean)</span></p>
<p class="noindent"><span><i>Meaning:</i> “Nutcase!”</span></p>
<p class="noindent"><span><i>Literally:</i> “Crazy animal baby!”</span></p>
<p class="noindent1a"><span><b><i>GEWADEE MASTAWCHI</i>!</b></span></p>
<p class="noindent"><span>(Kurdish)</span></p>
<p class="noindent"><span><i>Meaning:</i> “Sleazebag!”</span></p>
<p class="noindent"><span><i>Literally:</i> “Yogurt pimp!”</span></p>
<p class="noindent1a"><span><b><i>NI SHI SHENME DONGXI</i>!</b></span></p>
<p class="noindent"><span>(Mandarin)</span></p>
<p class="noindent"><span><i>Meaning:</i> “You’re inhuman!”</span></p>
<p class="noindent"><span><i>Literally:</i> “What kind of object are you!”</span></p>
<p class="noindent1a"><span><b><i>SUTKI PALA</i>!</b> (Polish)</span></p>
<p class="noindent"><span><i>Meaning:</i> “Chill out!”</span></p>
<p class="noindent"><span><i>Literally:</i> “Your nipples are burning!”</span></p>
<p class="noindent1a"><span><b><i>AIZVER ZAUNAS</i>!</b></span></p>
<p class="noindent"><span>(Latvian)</span></p>
<p class="noindent"><span><i>Meaning:</i> “Shut up!”</span></p>
<p class="noindent"><span><i>Literally:</i> “Close your gills!”</span></p>
<div class="box">
<p class="center7"><span><b>When heated, 2 Tbsp. of water convert into enough steam to fill a 12-gallon container.</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter020.vue?7482fc0c